import * as React from "react";
import { Icon } from "baseui/icon";
import { IconProps } from "baseui/icon";
import { useStyletron } from "kanopi-components/theme/useStyletron";

const CheckCircle: React.FC<IconProps> = (props) => {
  // This svg is using stroke rather than fill, which <Icon /> does not affect
  const [, theme] = useStyletron();
  const color = theme.colors[props.color] ?? props.color;

  return (
    // TODO: Should have the original viewBox from the source svg.
    <Icon viewBox="0 0 27 27" {...props}>
      <g fill="none">
        <path
          d="M8.483 13.075l3.59 3.59 7.01-7.01M25 13c0 6.627-5.373 12-12 12S1 19.627 1 13 6.373 1 13 1s12 5.373 12 12z"
          stroke={color}
        />
      </g>
    </Icon>
  );
};

export default CheckCircle;
